<template>
  <div
    :class="props.selected ? 'text-GOLD border-GOLD' : 'text-GREY border-GREY'"
    class="text-sm py-3 bg-TERTIARY font-semibold border-b"
  >
    <p class="line-clamp-1">{{ props.text }}</p>
  </div>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    default: 'Text'
  },
  selected: {
    type: Boolean,
    default: false
  }
})
</script>

<style></style>
